document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

  if (params.has('contact_posted')) {
    showToast('Wiadomość została wysłana! Odezwiemy się wkrótce.');

    // Usuwa parametr z adresu, żeby toast nie pojawiał się po odświeżeniu
    window.history.replaceState({}, document.title, window.location.pathname);
  }
});

function showToast(message, isError = false) {
  const toast = document.createElement('div');

  toast.textContent = message;

  Object.assign(toast.style, {
    position: 'fixed',
    left: '50%',
    bottom: '20px',
    transform: 'translateX(-50%) translateY(20px)',

    width: '90%',
    maxWidth: '300px',
    boxSizing: 'border-box',

    background: isError ? '#dc2626' : '#16a34a',
    color: '#fff',

    padding: '14px 24px',
    borderRadius: '8px',

    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',

    boxShadow: '0 10px 30px rgba(0,0,0,.2)',

    zIndex: '99999',
    opacity: '0',
    transition: 'all .3s ease'
    });

  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(20px)';

    setTimeout(() => toast.remove(), 300);
  }, 4000);
}